@if (this.me.role.slug === 'client') {
  <app-top-menu-client></app-top-menu-client>
} @else if (this.me.role.slug === 'worker') {
  @if (employee.meetingModeEnabled | async) {
    <div id="record-screen-banner">Modo reunión activado</div>
  }
  <app-top-menu-employee></app-top-menu-employee>
} @else if (this.me.role.slug === 'partner') {
  <app-top-menu-partner></app-top-menu-partner>
}

<div id="main-container" [class.minimized]="minimized">
  <input id="menu-toggler" name="menu-toggler" type="checkbox" />
  <label for="menu-toggler" id="menu-icon">
    <span class="menu-line"></span>
    <span class="menu-line"></span>
    <span class="menu-line"></span>
  </label>

  <nav id="main-menu">
    @if (this.me.role.slug === 'worker') {
      <app-lateral-menu-employee></app-lateral-menu-employee>
    } @else if (this.me.role.slug === 'client') {
      <app-lateral-menu-client></app-lateral-menu-client>
    } @else if (this.me.role.slug === 'partner') {
      <app-lateral-menu-partner></app-lateral-menu-partner>
    }

    <div id="minimize-button">
      <button mat-stroked-button type="button" (click)="toggleSidebar()">
        <mat-icon>chevron_left</mat-icon>
        <span>
          Esconder
          <span class="shortcut">Shift+Cmd+Space</span>
        </span>
      </button>
    </div>

    <div id="version-container">
      <p id="version">Bisual Intranet v{{ version }}</p>
    </div>
  </nav>

  @if (minimized) {
    <div id="maximize-button">
      <button mat-stroked-button type="button" (click)="toggleSidebar()">
        <span>Abrir</span>
        @if (employee.totalActionsRequired() > 0) {
          <span class="notification-badge">{{ employee.totalActionsRequired() }}</span>
        }
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  }

  <div id="content-container">
    <router-outlet></router-outlet>
  </div>
</div>
